import Skeleton from 'react-loading-skeleton';

const EditRequirementSkeletonCard = () => {
  return (
    <div className="w-full min-h-[70px] bg-white border border-transparent rounded-md shadow-md py-4 px-4 mb-4">
      <div className="flex items-center justify-between">
        <p className="text-indigo-600 text-xs font-normal">
          <Skeleton height={10} width={50} />
        </p>
        <Skeleton height={10} width={15} />
      </div>
      <div className=" flex gap-2 items-center">
        <p className="text-blue-950 text-sm font-medium capitalize">
          <Skeleton height={15} width={100} />
        </p>
        <p className="text-slate-500 text-xs font-medium">
          <Skeleton height={15} width={200} />
        </p>
      </div>
    </div>
  );
};

export default EditRequirementSkeletonCard;
